import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback, useEffect, useState } from 'react';
import { SimpleMarker } from 'shared/map/ui/components/marker/simple';
import { Box, Button, Typography } from '@mui/material';
import '../_general.sass';
import { UniversalDialog } from '../../dialogs/universal';
import { useUserLocationMarker } from 'shared/map/ui/components/marker/rotated/hook';
import { a2l } from 'shared/map/lib/utils';
import { MapWithControls } from 'shared/map/ui';
import { SetLocationComponent } from 'console/device-settings/location-dialog/set-location';
function LocationDialogImpl(props) {
    const { is_open, onRequestClose, starting_location, onSelect } = props;
    const loc = starting_location ? starting_location : [69.492188, 61.699211];
    const [location, setLocation] = useState(loc);
    const [OrientatedUserLocationMarker, mapCenterOnUser, user_location] = useUserLocationMarker(-1);
    useEffect(() => {
        if (is_open) {
            setLocation(loc);
        }
    }, [is_open, setLocation]);
    const onMoveEnd = useCallback((event) => {
        const marker_location = event.target.getLatLng();
        setLocation([marker_location.lng, marker_location.lat]);
    }, [setLocation]);
    const onClear = useCallback(() => {
        onSelect(undefined);
        onRequestClose();
    }, [onSelect, onRequestClose]);
    const onClickSave = useCallback(() => {
        onSelect(location);
        onRequestClose();
    }, [onSelect, location, onRequestClose]);
    const onSearchDone = useCallback((result) => {
        setLocation(result.loc);
    }, []);
    return (_jsx(UniversalDialog, { open: is_open, onClose: onRequestClose, title: "\u0423\u043A\u0430\u0436\u0438\u0442\u0435 \u043C\u0435\u0441\u0442\u043E\u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u0430", contentWithZeroPadding: true, footer: _jsxs(Box, { display: "flex", children: [_jsx(Box, { mr: 2, children: _jsx(Button, { onClick: onClear, children: "\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u044C" }) }), _jsx(Button, { color: "primary", variant: "contained", onClick: onClickSave, children: "\u0432\u044B\u0431\u0440\u0430\u0442\u044C" })] }), children: _jsxs(Box, { display: "flex", flexDirection: "column", minHeight: 300, children: [_jsx(Typography, { sx: { mx: 2 }, variant: "subtitle1", color: "textSecondary", children: location
                        ? `Выбрана точка Ш: ${location[1].toFixed(5)}, Д: ${location[0].toFixed(5)}`
                        : 'Не выбрано' }), _jsx("div", { className: "ui-location-dialog-map-container", children: _jsxs(MapWithControls, { showZoom: true, showOptionsMenu: true, showSearch: true, hide_for_map_dashboard: true, device_id: -1, onSearchDone: onSearchDone, mapCenterOnUser: mapCenterOnUser, children: [_jsx(SetLocationComponent, { setLocation: setLocation }), _jsx(SimpleMarker, { icon_class: "ui-location-dialog-target", position: location
                                    ? a2l(location)
                                    : user_location != null
                                        ? a2l(user_location)
                                        : a2l(loc), onMoveEnd: onMoveEnd, icon_width: 36, icon_height: 40, icon_anchor: [18, 36], draggable: true }), _jsx(OrientatedUserLocationMarker, {})] }) })] }) }));
}
export const LocationDialog = memo(LocationDialogImpl);
